import { Box, HStack, Text } from "@chakra-ui/react";
import {
  filesCategoryMessage,
  FILES_CATEGORY_VALUE_OTHER,
} from "@raiden/library/constants/files";
import getFileSize from "@raiden/library/helpers/files/getFileSize";
import useTranslate from "@raiden/library/hooks/useTranslate";
import capitalize from "@splitfire-agency/raiden-library/dist/libraries/utils/capitalize";
import { useIntl } from "react-intl";
import { Icon } from "../../../../../../components/Icon";
import {
  SEARCH_RESULTS_OBJECT_TYPE_FILE,
  SEARCH_RESULTS_TYPES,
} from "../../../../../../constants/search/results";
import { highlightSearchTerm } from "../../../../../../helpers/search/highlightSearchTerm";

/**
 * @typedef {Object} Props
 * @property {import("@raiden/library/types/search/Result").SearchResult} searchResult
 * @property {string} termValue
 */
/**
 * @param {Props} props
 */
export function SearchResultContent(props) {
  const { searchResult, termValue } = props;

  const intl = useIntl();

  const translate = useTranslate();

  return (
    <HStack
      py="3px"
      px="8px"
      borderRadius="inherit"
      _hover={{
        bg: "gray.200",
      }}>
      <Icon
        icon={
          SEARCH_RESULTS_TYPES[
            searchResult.metadata?.type ?? searchResult.object_type
          ].icon
        }
        size="24px"
        color="gray.400"
      />

      <Box>
        <Text
          w={{ base: "200px", sm: "auto" }}
          color="brandPrimary.700"
          wordBreak="break-word"
          noOfLines={1}>
          <span
            dangerouslySetInnerHTML={{
              __html: highlightSearchTerm(
                translate(searchResult.translations?.title) ?? "",
                termValue,
              ),
            }}
          />
        </Text>

        <HStack>
          <Text color="brandPrimary.600">
            {intl.formatMessage(
              SEARCH_RESULTS_TYPES[searchResult.metadata.type].label,
            )}
          </Text>

          {searchResult.metadata?.categories?.[0]?.name && (
            // Affiche la première catégorie d'un post
            <>
              {/* Séparateurs */}

              <Text color="brandPrimary.600">-</Text>

              <Text fontSize=".875rem" color="brandPrimary.600">
                {translate(searchResult.metadata.categories?.[0]?.name)}
              </Text>
            </>
          )}

          {searchResult.object_type === SEARCH_RESULTS_OBJECT_TYPE_FILE && (
            // Affiche le PATH d'un file
            <>
              {/* Séparateurs */}

              <Text color="brandPrimary.600">-</Text>

              <Text fontSize=".875rem" color="brandPrimary.600">
                {capitalize(
                  intl.formatMessage(filesCategoryMessage, {
                    category:
                      searchResult.metadata?.category ??
                      FILES_CATEGORY_VALUE_OTHER,
                  }),
                )}
              </Text>

              {/* Séparateurs */}

              <Text color="brandPrimary.600">-</Text>

              <Text fontSize=".875rem" color="brandPrimary.600">
                {getFileSize({
                  size: searchResult.metadata?.filesize,
                  intl,
                })}
              </Text>
            </>
          )}
        </HStack>
      </Box>
    </HStack>
  );
}
